import { AppRegistry } from 'react-native'

import App from 'app/src/App'

AppRegistry.registerComponent('KeepingCare', () => App)
AppRegistry.runApplication('KeepingCare', {
  rootTag: document.getElementById('root'),
})
